import { OligoForm } from 'src/models';
import {
  createResource,
  addOneNotification,
  setShowLoader,
  setHideLoader
} from 'src/core/redux/actions';
import { getErrorMessagesFromResponse } from 'src/utils/api';

export const submitAddToCart = (payload) => async (dispatch) => {
  dispatch(setShowLoader());

  const response = await dispatch(createResource(OligoForm)({
    rnaTubesSettingsRequests: [{ ...payload }]
  }));

  if (response.status === 200 || !response.status) {
    dispatch(setHideLoader());
    window.location.replace('/store/cart');

    return;
  }

  if (response.status !== 200) {
    const responseData = await response.json();
    const errorMessages = await getErrorMessagesFromResponse(responseData);

    dispatch(setHideLoader());

    dispatch(addOneNotification({
      type: 'error',
      message: errorMessages[0],
    }));
  }
};
